import React, { useState } from 'react'
import TranscriptLine from './transcriptline'
import { WebVTTParser } from 'webvtt-parser'
import { ClockIcon } from '@/icons'

const Transcript = ({ transcript, seek, currentTime }) => {
  const [showTime, setShowTime] = useState(false)
  const renderTranscript = () => {
    if (transcript) {
      if (transcript.startsWith('WEBVTT')) {
        try {
          const parser = new WebVTTParser()
          const tree = parser.parse(transcript)
          return tree && tree.cues ? (
            <>
              <div className="flex justify-content-end transcript-controls">
                <button
                  onClick={() => setShowTime((prevState) => !prevState)}
                  outline
                  size="sm"
                  className={`plyr-btn obro-btn ${
                    showTime ? 'active' : ''
                  }`}
                >
                  <ClockIcon />
                </button>
              </div>

              {tree.cues.map((cue, i) => (
                <TranscriptLine
                  key={`line-${i}`}
                  cue={cue}
                  active={false}
                  seek={seek}
                  currentTime={currentTime}
                  showTime={showTime}
                />
              ))}
            </>
          ) : null
        } catch (err) {
          console.error(err)
          return <pre>{transcript}</pre>
        }
      } else {
        return (
          <pre
            className="text"
            style={{
              'word-wrap': 'break-word',
              'white-space': 'pre-wrap',
              'font-family': 'Inter'
            }}
          >
            {transcript}
          </pre>
        )
      }
    } else {
      return ''
    }
  }

  return <div className="track">{renderTranscript()}</div>
}

export default Transcript
